"use strict";

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Decimal = void 0;

var tslib_1 = require("tslib");

var ethers_1 = require("ethers");

var tiny_invariant_1 = tslib_1.__importDefault(require("tiny-invariant"));
/**
 * Decimal is a class to make it easy to go from Javascript / Typescript `number` | `string`
 * to ethers `BigDecimal` with the ability to customize precision
 */


var Decimal = /*#__PURE__*/function () {
  function Decimal() {
    _classCallCheck(this, Decimal);
  }

  _createClass(Decimal, null, [{
    key: "new",
    value:
    /**
     * Returns a `DecimalValue` type from the specified value and precision
     * @param value
     * @param precision
     */
    function _new(value) {
      var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 18;
      tiny_invariant_1.default(precision % 1 == 0 && precision <= 18 && precision > -1, "".concat(precision.toString(), " must be a non-negative integer less than or equal to 18")); // if type of string, ensure it represents a floating point number or integer

      if (typeof value == 'string') {
        tiny_invariant_1.default(value.match(/^[-+]?[0-9]*\.?[0-9]+$/), 'value must represent a floating point number or integer');
      } else {
        value = value.toString();
      }

      var decimalPlaces = Decimal.countDecimals(value); // require that the specified precision is at least as large as the number of decimal places of value

      tiny_invariant_1.default(precision >= decimalPlaces, "Precision: ".concat(precision, " must be greater than or equal the number of decimal places: ").concat(decimalPlaces, " in value: ").concat(value));
      var difference = precision - decimalPlaces;
      var zeros = ethers_1.BigNumber.from(10).pow(difference);
      var abs = ethers_1.BigNumber.from("".concat(value.replace('.', '')));
      return {
        value: abs.mul(zeros)
      };
    }
    /**
     * Returns the raw `DecimalValue` with no precision
     * @param value
     */

  }, {
    key: "raw",
    value: function raw(value) {
      return {
        value: ethers_1.BigNumber.from(value)
      };
    }
    /**
     * Returns the number of decimals for value
     * @param value
     */

  }, {
    key: "countDecimals",
    value: function countDecimals(value) {
      if (value.includes('.')) return value.split('.')[1].length || 0;
      return 0;
    }
  }]);

  return Decimal;
}();

exports.Decimal = Decimal;